// eslint-disable-next-line import/no-cycle
import {
  stringLogicalOperators,
  numberLogicalOperators,
  dateStringLogicalOperators,
  selectionBasedLogicalOperators,
} from '@/composables/segmentations/logicalOperators';

const voucherTypeOptions = [
  { label: 'segmentations.voucher.list.type_options.percentage', value: '1' },
  { label: 'segmentations.voucher.list.type_options.amount', value: '2' },
  { label: 'segmentations.voucher.list.type_options.shipping_fees', value: '3' },
  { label: 'segmentations.voucher.list.type_options.duplicated', value: '4' },
];

/**
 * Get voucher properties segments for conditional display in template builder.
 * These segments allow filtering based on voucher configuration data.
 */
const getVoucherSegments = () => ({
  id: 'voucher',
  label: 'segmentations.voucher.label',
  list: [
    {
      id: 'voucher_is_configured',
      label: 'segmentations.voucher.list.is_configured',
      options: [
        { label: 'yes', value: true },
        { label: 'no', value: false },
      ],
      data: true,
      context: 'voucher.is_configured',
    },
    {
      id: 'voucher_code',
      label: 'segmentations.voucher.list.code',
      logical_operators: stringLogicalOperators('voucher_code'),
      context: 'voucher.code',
    },
    {
      id: 'voucher_description',
      label: 'segmentations.voucher.list.description',
      logical_operators: stringLogicalOperators('voucher_description'),
      context: 'voucher.description',
    },
    {
      id: 'voucher_date_start',
      label: 'segmentations.voucher.list.date_start',
      logical_operators: dateStringLogicalOperators('voucher_date_start'),
      context: 'voucher.date_start',
    },
    {
      id: 'voucher_date_end',
      label: 'segmentations.voucher.list.date_end',
      logical_operators: dateStringLogicalOperators('voucher_date_end'),
      context: 'voucher.date_end',
    },
    {
      id: 'voucher_type',
      label: 'segmentations.voucher.list.type',
      logical_operators: selectionBasedLogicalOperators('voucher_type', voucherTypeOptions),
      context: 'voucher.type',
    },
    {
      id: 'voucher_amount',
      label: 'segmentations.voucher.list.amount',
      logical_operators: numberLogicalOperators('voucher_amount'),
      context: 'voucher.amount',
    },
    {
      id: 'voucher_minimum_order',
      label: 'segmentations.voucher.list.minimum_order',
      logical_operators: numberLogicalOperators('voucher_minimum_order'),
      context: 'voucher.minimum_order',
    },
    {
      id: 'voucher_nb_day_validate',
      label: 'segmentations.voucher.list.nb_day_validate',
      logical_operators: numberLogicalOperators('voucher_nb_day_validate'),
      context: 'voucher.nb_day_validate',
    },
  ],
});

export default getVoucherSegments;
